import React from 'react';
import { Hero } from './components/Hero';
import { Evolution } from './components/Evolution';
import { WhoWeAre } from './components/WhoWeAre';
import { SocialProof } from './components/SocialProof';
import { Gallery } from './components/Gallery';
import { Masterclass } from './components/Masterclass';
import { WhatYoullLearn } from './components/WhatYoullLearn';
import { ForYouIf } from './components/ForYouIf';
import { Founder } from './components/Founder';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-cream selection:bg-forest-light selection:text-cream" data-id="element-0">
      <Hero data-id="element-1" />
      <Evolution data-id="element-2" />
      <WhoWeAre data-id="element-3" />
      <SocialProof data-id="element-4" />
      <Gallery data-id="element-5" />
      <Masterclass data-id="element-6" />
      <WhatYoullLearn data-id="element-7" />
      <ForYouIf data-id="element-8" />
      <Founder data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </main>;
}